import api from './api';

export const employeesAPI = {
  getTeachersForClassSection: () => api.get(`/employees/get-teachers-for-class-section`),
  getAllEmployees: () => api.get('employees/get-all-employees'),
  getEmployeesByParamas: (params = {}) => api.get(`/employees/get-employees-by-params`, { params }),

  getDepartments: () => api.get(`/employees/get-departments`),

  getSupervisors: () => api.get(`/employees/get-supervisors`),

  addEmployee: (employeeData) => api.post(`/employees/add-employee`, employeeData),

  updateEmployee: (employeeId, employeeData) => api.put(`/employees/update-employee/${employeeId}`, employeeData),

  deleteEmployee: (employeeId) => api.delete(`/employees/delete-employee/${employeeId}`),

  getSalaryStatusSummary: () => api.get(`/employees/salary-status-summary`),

  processSalary: (data) => api.post(`/employees/process`, data),

  paySalary: (data) => api.post(`/employees/pay`, data),

  createMonthlySalary: () => api.post(`/employees/create-month-salary`),

  getSalaryHistory: (employeeId) => api.get(`/employees/salary-history/${employeeId}`),
  getAdmissioners: () => api.get(`/employees/get-admissioners`),

  getEmployeeByUserId: (userId) => api.get(`/employees/get-teacher/${userId}`)
};
